// Client-side slug format faults only, mirroring the server regex (EIT-112).
// slug_reserved (server denylist) and slug_taken (availability) are server-only
// signals surfaced from the POST response — never decided here.
export type SlugFault = 'slug_missing' | 'slug_too_long' | 'slug_malformed';

const SLUG_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

export function validateSlug(slug: string): SlugFault | null {
  if (slug.length === 0) return 'slug_missing';
  if (slug.length > 63) return 'slug_too_long';
  if (!SLUG_RE.test(slug)) return 'slug_malformed';
  return null;
}
